import * as Sentry from '@sentry/browser';
import * as React  from 'react';
import ErrorUI from '../ErrorUI/ErrorUI';

interface IRegisterFormBoundaryState {
  hasError: boolean;
  error?: any;
}

export default class RegisterFormErrorBoundary extends React.Component<any, IRegisterFormBoundaryState> {
  constructor(props: any){
    super(props);

    this.state = {
      hasError: false
    }
  }

  public componentDidCatch(error: Error, info: any) {

    Sentry.configureScope( (scope) => {
      scope.setLevel(Sentry.Severity.Error);
      scope.setTag("renderRegisterForm", 'REGISTER_FORM');
      scope.setExtra("error", error);
    });
    Sentry.captureMessage("Error: Render RegisterForm");

    this.setState({
      hasError: true
    });
  }

  public render(){
    if (this.state.hasError) {
      return (
        <ErrorUI/>
      );
    } else {
      return this.props.children;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Register/RegisterFormErrorBoundary.tsx